import type { ReactNode } from 'react'

import { cn } from '@massilia/ui'

interface BookingStepActionsProps {
  className?: string
  children: ReactNode
}

/**
 * Conteneur des boutons de navigation (retour / confirmation) des étapes du flow
 * de réservation. Sur mobile il devient un footer sticky pleine largeur ; sur
 * desktop il revient au rendu inline. On utilise `sticky` (pas un portal) afin que
 * les boutons restent dans le `<form>` et que les `type="submit"` fonctionnent.
 */
export function BookingStepActions({ className, children }: BookingStepActionsProps) {
  return (
    <div
      className={cn(
        // Mobile : footer sticky pleine largeur (annule le px-4 du form via -mx-4)
        'sticky bottom-0 z-10 -mx-4 mt-2 flex items-center justify-between gap-2 border-t border-gray-light-200 bg-white px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]',
        // Mobile : chaque bouton occupe une part égale (moitié/moitié à deux, plein
        // à un seul) — annule les largeurs fixes des boutons qui débordaient.
        '[&>*]:min-w-0 [&>*]:flex-1',
        // Desktop : retour au rendu inline + largeurs naturelles des boutons
        'md:static md:mx-0 md:mt-0 md:border-0 md:bg-transparent md:p-0 md:[&>*]:flex-none',
        className
      )}
    >
      {children}
    </div>
  )
}
